export default {
    computed: {
        options() {
            return this.$store.state.options;
        },
        curRecipe() {
            return this.$store.state.curRecipe;
        },
    },
    methods: {
        /**
         * commit recipe options
         * @param recipe
         */
        loadRecipe(recipe) {
            // reset active filters
            this.$store.commit('resetFilters');

            // set bun name in input filed
            if ((recipe.name !== undefined) && (recipe.name != '')) // bugfix - when selecting new empty bun => do not reset name
                this.$store.commit('setFieldValue', {field: 'recipeName', value: recipe.name});

            // prepare to commit when recipe contains a name
            if ((recipe.name !== undefined) && (recipe.name.length >= 3)) {
                this.$store.commit('setSubmissionStatus', true);
            }

            this.$store.commit('setEmojiMap', recipe.emojiMap !== undefined? recipe.emojiMap: [])

            //loop all options
            for (let i = 0; i < this.options.length; i++) {
                //make singular option type name
                let type = this.options[i].slice(0, -1);

                //set option id if given otherwise an empty object
                let option = recipe[type] === undefined ? {} : recipe[type];
                //commit option change
                this.$store.commit('selectOption', {type, option});
            }
        },

        /**
         * get singular name of option
         * @param option
         * @return string
         */
        sOptionName(option) {
            return option.slice(0, -1);
        }
    }
}